import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { Deployment } from "@/types";

// Deployment stilllegen (idempotent). Danach verweigert das Portal Refreshes → der
// Master degradiert sanft. licenseId noetig, um die Deployments-Sub-Liste zu invalidieren.
export function useDeactivateDeployment(): UseMutationResult<
  Deployment,
  Error,
  { id: string; licenseId: string }
> {
  const { session, logout } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.post<Deployment>(`/deployments/${id}/deactivate`, {});
    },
    onSuccess: (_data, { licenseId }) =>
      qc.invalidateQueries({ queryKey: queryKeys.subResource("licenses", licenseId, "deployments") }),
  });
}
